export enum UserType {
  None,
  Employee,
  Contractor,
  Resident,
}

export enum VendorEmployeeType {
  VendorAndEmployee,
  Vendor,
}

export enum UserPermissionsMap {
  BB2F_RequiresAcceptance = 107,
}
